import React, {useContext, useEffect, useState} from "react";
import {Context} from "../../../App";
import {useTranslation} from "react-i18next";
import ModalWindow from "../../modal";
import {Link, Outlet, useParams} from "react-router-dom";
import {Breadcrumb, Button, Card, Col, Descriptions, Divider, Row, Skeleton, Space, Table, Tag, Tooltip} from "antd";
import moment from "moment";
import DB_Sale from "../../../database/document/sale";
import {EditOutlined, LockOutlined, UnlockOutlined} from "@ant-design/icons";
import DrawerTradePoint from "../../dictionary/trade-point/trade-point/drawer_trade_point";
import BackButton from "../../tech/back_button";
import {TradePointModel} from "../../../model/trade_point_model";


const Sale = () => {
    const {sale_id} = useParams()
    const {token, user, setToken} = useContext(Context)
    const {t} = useTranslation()
    const {getSale, blockSale, changeStatus} = DB_Sale(token)
    const {errorConnect} = ModalWindow()
    const [wait, setWait] = useState(true)
    // const [data, setData] = useState({})
    const [detailsData, setDetailsData] = useState([])
    const [openDrawerTradePoint, setOpenDrawerTradePoint] = useState(false)

    let [data, setData] = useState({
        date: null,
        invoice_number: null,
        branch_id: null,
        branch: null,
        org_structure_id: null,
        org_structure: null,
        doc_type_id: null,
        doc_type: null,
        warehouse_id: null,
        warehouse: null,
        status: null,
        total_without_tax: null,
        tax: null,
        total_with_tax: null,
        block_time: null,
        block_user: null,
        block_user_id: null,
        ulm: null,
        dlm: null,
        trade_point: TradePointModel,
        details: []
    })

    const [block, setBlock] = useState({
        block_user: null,
        block_user_id: null,
        block_time: null,
        status: false
    })
    const [status, setStatus] = useState(1)


    const columns = [

        {
            title: "#",
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: t('code'),
            dataIndex: 'vendor_code_id',
        },
        {
            title: t('sku'),
            dataIndex: 'vendor_code',
        },
        {
            title: t('quantity'),
            dataIndex: 'count',
        },
        {
            title: t('price'),
            dataIndex: 'price',
        },
        {
            title: t('sum_without_tax'),
            dataIndex: 'sum_without_tax',
        },
        {
            title: t('tax'),
            dataIndex: 'tax',
        },
        {
            title: t('sum_with_tax'),
            dataIndex: 'sum_with_tax',
        },

    ]


    useEffect(() => {
        window.scroll(0, 0)
        if (sale_id != null) {
            getSale(sale_id)
                .then(res => {
                    setData(res.data)
                    setDetailsData(res.data.details)
                    setBlock({
                        block_user: res.data.block_user,
                        block_user_id: res.data.block_user_id,
                        block_time: res.data.block_time,
                        status: res.data.block_time != null
                    })
                    setStatus(res.data.status)
                    setWait(false)
                })
                .catch(e => {
                    if (e.response.status === 403) {
                        setToken(null)
                    }
                    errorConnect()
                    setWait(false)
                });
        }

    }, [])

    const clickBlockSale = () => {
        const formData = new FormData()
        formData.append('sale_id', sale_id)

        blockSale(formData)
            .then(res => {
                if (res.status === 200) {
                    setBlock({
                        block_user: res.data.block_user,
                        block_user_id: res.data.block_user_id,
                        block_time: res.data.block_time,
                        status: res.data.block_time != null
                    })
                }
            })
            .catch(e => {
                if (e.response.status === 403) {
                    setToken(null)
                }
                if (e.response.status === 402) {
                    console.log("Not found invoice")
                }
                errorConnect()
            })
    }

    const ClickChangeStatus = () => {
        const formData = new FormData()
        formData.append('sale_id', sale_id)

        changeStatus(formData)
            .then(res => {
                if (res.status === 200) {
                    setStatus(status ? 0 : 1)
                }
            })
            .catch(e => {
                if (e.response.status === 403) {
                    setToken(null)
                }
                if (e.response.status === 402) {
                    console.log("Not found invoice")
                }
                errorConnect()
            })
    }

    const BlockButton = () => {
        if (user.role_id === 1) {
            return (
                <Tooltip placement={'bottomRight'} title={t('block_invoice')}>
                    <Button
                        icon={block.status ? <UnlockOutlined/> : <LockOutlined/>}
                        danger={block.status}
                        onClick={clickBlockSale}
                        style={{margin: '0 5pt'}}
                        disabled={block.status && block.block_user_id !== user.id}
                    >
                        {block.status ? moment(block.block_time).format("DD.MM.YYYY HH:mm") + ' ' + block.block_user : null}
                    </Button>
                </Tooltip>
            )
        }
    }

    const StatusButton = () => {
        if (user.role_id !== 1 || block.status) {
            return (
                <Tag color={status === 1 ? 'green' : 'volcano'} key={status}>
                    {status === 1 ? t('active') : t('disable')}
                </Tag>
            )
        } else {
            return (
                <Tooltip placement={'bottom'} title={t('change_status_invoice')}>
                    <Button type={'link'} onClick={ClickChangeStatus}>
                        <Tag color={status === 1 ? 'green' : 'volcano'} key={status}>
                            {status === 1 ? t('active') : t('disable')}
                        </Tag>
                    </Button>
                </Tooltip>
            )

        }
    }

    const ModifiedInvoice = () => {
        if (data.ulm != null) {
            return (
                <Tooltip placement={'bottom'} title={t('modified_invoice', {user: data.ulm, date: moment(data.dlm).format('HH:mm DD.MM.YYYY')})}>
                    <span style={{color:'red', cursor:'pointer'}}>*</span>
                </Tooltip>
            )
        }
    }



    const EditButton = () => {
        // if (user.role_id === 1) {
            return (
                <Tooltip placement={'bottomRight'} title={t('edit_invoice')}>
                    <Link to={"edit"} state={{id: sale_id}}>
                        <Button
                            icon={<EditOutlined />}
                            style={{margin: '0 5pt'}}
                            disabled={block.status}
                        />
                    </Link>

                </Tooltip>
            )
        // }
    }


    return (
        <>
            <div className="page">
                <Space
                    style={{
                        width: '100%',
                        justifyContent: 'space-between'
                    }}>
                    <Breadcrumb
                        style={{
                            margin: '15pt 0',
                        }}
                    >
                        <Breadcrumb.Item>
                            <span className={'ant-page-header-heading-title'} style={{paddingLeft:'24px'}}>
                                {t('sale')}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>

                    <Space>
                        <BackButton/>
                    </Space>
                </Space>

                <Card
                    title={<>{t('invoice') + data.invoice_number} <ModifiedInvoice/></>}
                    extra={[
                        <StatusButton key={3}/>,
                        <BlockButton key={2}/>,
                        <EditButton key={1}/>,
                    ]
                    }
                >
                    <Skeleton loading={wait} active>
                        <Descriptions>
                            <Descriptions.Item label={t('date')}>
                                <span
                                    style={{fontFamily: 'Montserrat-Medium'}}>{moment(data.date).format("DD.MM.YYYY")}</span>
                            </Descriptions.Item>

                            <Descriptions.Item label={t('branch')} span={2}>
                                <span style={{fontFamily: 'Montserrat-Medium'}}>{data.branch}</span>
                            </Descriptions.Item>

                            <Descriptions.Item label={t('warehouse')}>
                                <span style={{fontFamily: 'Montserrat-Medium'}}>{data.warehouse}</span>
                            </Descriptions.Item>

                            <Descriptions.Item label={t('org_structure_s')} span={2}>
                                <span style={{fontFamily: 'Montserrat-Medium'}}>{data.org_structure}</span>
                            </Descriptions.Item>

                            <Descriptions.Item label={t('doc_type')}>
                                <span style={{fontFamily: 'Montserrat-Medium'}}>{data.doc_type}</span>
                            </Descriptions.Item>

                            <Descriptions.Item label={t('trade_point')} span={2}>
                                {/*<span style={{fontFamily: 'Montserrat-Medium'}}>{data.trade_point}</span>*/}
                                <Button type={'link'} style={{height:'auto', padding:'0'}} onClick={e => setOpenDrawerTradePoint(true)}>
                                    <span style={{fontFamily: 'Montserrat-Medium'}} >{data.trade_point.name}</span>
                                </Button>
                            </Descriptions.Item>


                        </Descriptions>
                    </Skeleton>
                    <Divider/>

                    <Table
                        style={{'--cursor': "auto" }}
                        columns={columns}
                        dataSource={detailsData}
                        rowKey="id"
                        loading={wait}
                        pagination={false}
                        size={"small"}
                    />

                    <Card bordered={false}>
                        <Skeleton loading={wait} active>
                            <Row gutter={8}>
                                <Col span={4} offset={16} style={{display: 'flex', justifyContent: 'flex-end'}}>
                                    <p>{t('total_without_tax')}</p>
                                </Col>
                                <Col span={4} style={{display: 'flex', justifyContent: 'flex-end'}}>
                                    <span style={{fontFamily: 'Montserrat-Medium'}}>{data.total_without_tax}</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={4} offset={16} style={{display: 'flex', justifyContent: 'flex-end'}}>
                                    <p>{t('tax') + ":"}</p>
                                </Col>
                                <Col span={4} style={{display: 'flex', justifyContent: 'flex-end'}}>
                                    <span style={{fontFamily: 'Montserrat-Medium'}}>{data.tax}</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={4} offset={16} style={{display: 'flex', justifyContent: 'flex-end'}}>
                                    <p>{t('total_with_tax')}</p>
                                </Col>
                                <Col span={4} style={{display: 'flex', justifyContent: 'flex-end'}}>
                                    <span style={{fontFamily: 'Montserrat-Medium'}}>{data.total_with_tax}</span>
                                </Col>
                            </Row>
                        </Skeleton>
                    </Card>

                </Card>


            </div>

            <DrawerTradePoint
                trade_point={data.trade_point}
                show={openDrawerTradePoint}
                setShow={setOpenDrawerTradePoint}/>

            <Outlet/>
        </>
    )
}

export default Sale;